import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from '../../app/components/components.module';
import { TranslateModule } from '@ngx-translate/core';
import { HomePage } from './home';
import { UserModule } from '../../app/services/user/user.module';

@NgModule({
  declarations: [
    HomePage
  ],
  imports: [
    IonicPageModule.forChild(HomePage),
    TranslateModule.forChild(),
    ComponentsModule,
    UserModule.forRoot()
  ],
})
export class HomePageModule {}


// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts